import React, { useEffect, useState } from "react";
import { Dropdown, Spinner, Button, Badge } from "react-bootstrap";
import { BellFill } from "react-bootstrap-icons";
import { useNavigate } from "react-router-dom";
import { NOTIFICATION_COUNT, NOTIFICATION_DATA, READ_NOTIFICATION } from "../../services/ApiCalls";
import { useSocket } from "../../Socket/socketProvider";

const NotificationBell = () => {
    const navigate = useNavigate();
    const { notify, setNotify } = useSocket();
    const [hasUnread, setHasUnread] = useState(false);
    const [notifications, setNotifications] = useState([]);
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(0);
    const [loading, setLoading] = useState(false);
    const [open, setOpen] = useState(false);

    const loadNotifications = async (pageNo = 1, append = false) => {
        const body = {
            limit: 10,
            page: pageNo ?? 1,
            orderField: "createdAt",
            order: 0
        }

        try {
            setLoading(true);
            const res = await NOTIFICATION_DATA(body);
            const list = res?.data?.data || [];
            const total = Math.ceil(res?.data?.totalcount / 10) || 1;
            setTotalPages(total >= 1 ? total : 1);
            setNotifications((prev) =>
                append ? [...prev, ...list] : list
            );
        } catch (err) {
            console.error("Failed to load notifications", err);
        } finally {
            setLoading(false);
        }
    };

    const handleToggle = (isOpen) => {
        setOpen(isOpen);
        if (isOpen) {
            loadNotifications(1);
        }
    };

    const loadMore = () => {
        const next = page + 1;
        setPage(next);
        loadNotifications(next, true);
    };


    const readOnClick = async (item) => {
        try {
            const resp = await READ_NOTIFICATION({ id: item?._id })
            console.log("resp", resp);

            if (resp.data.status === "success") {
                getNotifyCount();
                loadNotifications(1)
            }
            if (item.navigationLink) {
                if (item?.is_read === false) {
                    navigate(item.navigationLink);
                    setOpen(false);
                }

            }
        } catch (err) {
            console.log("err", err);
        }
    }
    const getNotifyCount = async () => {
        try {
            const resp = await NOTIFICATION_COUNT()
            setHasUnread(resp?.data?.data)
        } catch (err) {
            console.log("err", err);
        }
    }


    useEffect(() => {
        if (notify) {
            getNotifyCount();
        }
        setNotify(false);
    }, [notify])

    useEffect(() => {
        getNotifyCount();
    }, [])


    return (
        <Dropdown show={open} onToggle={handleToggle} align="start">
            <Dropdown.Toggle variant="light" className="border-0 position-relative">
                <BellFill size={20} />
                {hasUnread > 0 && (
                    <p style={{ height: "10px", width: "10px", borderRadius: "100%", backgroundColor: "red", marginLeft: 15 }} className="position-absolute top-0 start-75  ">

                    </p>
                )}
            </Dropdown.Toggle>

            <Dropdown.Menu
                className="shadow p-0"
                style={{
                    width: "380px",
                    maxHeight: "420px",
                    overflowY: "auto",
                    marginTop: "12px",
                    marginLeft: window.innerWidth >= 992 ? 0 : -180
                }}
            >
                <div className="px-3 py-2 fw-bold border-bottom">
                    Notifications
                </div>

                {notifications.length === 0 && !loading && (
                    <div className="text-center text-muted py-4">
                        No notifications
                    </div>
                )}

                {loading && (
                    <div className="text-center py-2">
                        <Spinner animation="border" size="sm" />
                    </div>
                )}
                {notifications.map((item) => (
                    <div
                        key={item._id}

                        className={`px-3 py-2 border-bottom notification-item `}
                        style={{ cursor: "pointer", backgroundColor: !item.is_read ? "#D9D9D9" : "" }}
                        onClick={() => readOnClick(item)}
                    >
                        <div className="d-flex justify-content-between align-items-start">
                            <div className="fw-semibold" style={{ fontSize: "14px" }}>
                                {item.title}
                            </div>
                            {item.type && (
                                <Badge bg="secondary" style={{ fontSize: "10px" }}>
                                    {item.type}
                                </Badge>
                            )}
                        </div>

                        <div
                            className="text-muted mt-1"
                            style={{ fontSize: "12px", lineHeight: "1.4" }}
                        >
                            {item.body}
                        </div>

                        {item.data?.guestName && (
                            <div className="text-muted mt-1" style={{ fontSize: "11px" }}>
                                Guest: {item.data.guestName}
                            </div>
                        )}
                    </div>
                ))}



                {page < totalPages && !loading && (
                    <div className="text-center p-2">
                        <Button size="sm" variant="primary" onClick={loadMore}>
                            Load More
                        </Button>
                    </div>
                )}
            </Dropdown.Menu>
        </Dropdown>
    );
};

export default NotificationBell;
